import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import bg5 from "../../assets/images/hero/bg5.jpg";
import team1 from "../../assets/images/team/01.jpg";
import { Link } from "react-router-dom";
import { api } from "../..";
import { useAuth } from "../../utility/auth";

export default function CandidateProfileSetting() {
  const auth = useAuth();
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [skillform, setSkillform] = useState({
    name: "",
    proficiency: 0,
  });
  const handleSkillChange = (e) => {
    const { name, value } = e.target;
    // console.log("in skill change ", name, value, e.target);
    setSkillform((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [expform, setExpform] = useState({
    name: "",
    years: 0,
    location: "",
    info: "",
  });
  const handleExpChange = (e) => {
    const { name, value } = e.target;
    console.log("in skill change ", name, value, e.target);
    setExpform((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [userform, setUserform] = useState({
    fname: "",
    lname: "",
    email: "",
    location: "",
    phone: "",
    website: "",
    intro: "",
    Jobrole: "",
    Country: "",
  });
  const handleUserChange = (e) => {
    const { name, value } = e.target;
    console.log("in skill change ", name, value, e.target);
    setUserform((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleUserSubmit = async () => {
    try {
      console.log("submitting data ", skills, experiences);
      const response = await fetch(`${api}/save-profile`, {
        method: "POST", // or 'POST' depending on your API method
        headers: {
          Authorization: `Bearer ${auth.token}`, // Adding Bearer token in the header
          "Content-Type": "application/json", // Optional, depending on your API
        },
        body: JSON.stringify({
          userData: userform,
          skillData: skills,
          expData: experiences,
        }), // Convert the body to a JSON string
        // body: {
        //   userData: userform,
        //   skillData: skillform,
        //   expData: expform,
        // },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(" user profile saved >>>>>", data);
        alert("data saved successfully");
        // setJobData(data.all_jobs);
      } else {
        // console.log(response);
        // alert("failed to save data");
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      alert("failed to save data " + error);
    }
  };

  useEffect(() => {
    const fetchCompaniesData = async () => {
      try {
        const response = await fetch(`${api}/get-profile`, {
          method: "GET", // or 'POST' depending on your API method
          headers: {
            Authorization: `Bearer ${auth.token}`, // Adding Bearer token in the header
            "Content-Type": "application/json", // Optional, depending on your API
          },
        });
        if (response.ok) {
          const data = await response.json();
          console.log("DATA FROM user profile>>>>>", data);
          setUserform(data.userData);
          setSkills(data.skillData);
          setExperiences(data.expData);
          // setJobData(data.all_jobs);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchCompaniesData();
  }, []);

  // const checkForms = async (e) => {
  //   console.log("This is e target form value ", e.target);
  // };

  return (
    <>
      <Navbar />
      <section className="relative lg:mt-24 mt-[74px] pb-16">
        <div className="lg:container container-fluid">
          <div className="profile-banner relative text-transparent">
            <input
              id="pro-banner"
              name="profile-banner"
              type="file"
              className="hidden"
            />
            <div className="relative shrink-0">
              <img
                src={bg5}
                className="h-64 w-full object-cover lg:rounded-xl shadow dark:shadow-gray-700"
                id="profile-banner"
                alt=""
              />
              <label
                className="absolute inset-0 cursor-pointer"
                htmlFor="pro-banner"
              ></label>
            </div>
          </div>
          <div className="md:flex mx-4 -mt-12">
            <div className="md:w-full">
              <div className="relative flex items-end">
                <div className="profile-pic text-center">
                  <input
                    id="pro-img"
                    name="profile-image"
                    type="file"
                    className="hidden"
                  />
                  <div>
                    {/* <div className="relative size-28 max-w-[112px] max-h-[112px] mx-auto">
                      <img
                        src={""}
                        className="rounded-full shadow dark:shadow-gray-800 ring-4 ring-slate-50 dark:ring-slate-800"
                        id="profile-image"
                        alt=""
                      />
                      <label
                        className="absolute inset-0 cursor-pointer"
                        htmlFor="pro-img"
                      ></label>
                    </div> */}
                  </div>
                </div>
                <div className="mt-20">
                  <h5 className="text-lg font-semibold">{userform.fname}</h5>
                  <p className="text-slate-400">{userform.Jobrole}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-16">
          <div className="grid grid-cols-1 gap-[30px]">
            <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <h5 className="text-lg font-semibold mb-4">Personal Detail :</h5>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log(userform);
                  // handleUserSubmit();
                }}
              >
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div>
                    <label className="form-label font-medium">
                      First Name : <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="First Name:"
                      id="firstname"
                      name="fname"
                      onChange={handleUserChange}
                      required
                      value={userform.fname}
                    />
                  </div>
                  <div>
                    <label className="form-label font-medium">
                      Last Name : <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Last Name:"
                      id="lastname"
                      value={userform.lname}
                      onChange={handleUserChange}
                      name="lname"
                      required
                    />
                  </div>
                  <div>
                    <label className="form-label font-medium">
                      Your Email : <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Email"
                      name="email"
                      onChange={handleUserChange}
                      value={userform.email}
                      required
                    />
                  </div>
                  {/* <div>
                    <label className="form-label font-medium">
                      Occupation :
                    </label>
                    <select className="form-select form-input border border-slate-100 dark:border-slate-800 block w-full mt-2">
                      <option value="WD">Web Designer</option>
                      <option value="WD">Web Developer</option>
                      <option value="UI">UI / UX Desinger</option>
                    </select>
                  </div> */}
                  <div>
                    <label className="form-label font-medium">Location :</label>
                    <input
                      type="text"
                      className=" form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Location:"
                      id="location"
                      name="location"
                      value={userform.location}
                      onChange={handleUserChange}
                      required
                    />
                  </div>
                  <div>
                    <label className="form-label font-medium">Country :</label>
                    <input
                      type="text"
                      className=" form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Country:"
                      id="Country"
                      name="Country"
                      value={userform?.Country}
                      onChange={handleUserChange}
                      required
                    />
                  </div>
                  <div>
                    <label className="form-label font-medium">Jobrole :</label>
                    <input
                      type="text"
                      className=" form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Jobrole:"
                      id="Jobrole"
                      name="Jobrole"
                      value={userform?.Jobrole}
                      onChange={handleUserChange}
                      required
                    />
                  </div>
                  {/* <div>
                    <label
                      className="form-label font-medium"
                      htmlFor="multiple_files"
                    >
                      Upload Resume:
                    </label>
                    <input
                      className="relative form-input border border-slate-100 dark:border-slate-800 file:h-10 file:-mx-3 file:-my-2 file:cursor-pointer file:rounded-none file:border-0 file:px-3 file:text-neutral-700 bg-clip-padding px-3 py-1.5 file:me-3 mt-2"
                      id="multiple_files"
                      type="file"
                      multiple
                    />
                  </div> */}

                  <div>
                    <label className="form-label font-medium">
                      Phone No. :
                    </label>
                    <input
                      name="phone"
                      id="number"
                      type="number"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Phone :"
                      value={userform.phone}
                      onChange={handleUserChange}
                    />
                  </div>

                  <div>
                    <label className="form-label font-medium">Website :</label>
                    <input
                      name="website"
                      id="url"
                      type="url"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                      placeholder="Url :"
                      value={userform.website}
                      onChange={handleUserChange}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1">
                  <div className="mt-5">
                    <label className="form-label font-medium">Intro : </label>
                    <textarea
                      name="intro"
                      id="comments"
                      className="form-input border border-slate-100 dark:border-slate-800 mt-2 textarea"
                      placeholder="Intro :"
                      value={userform.intro}
                      onChange={handleUserChange}
                    ></textarea>
                  </div>
                </div>
                {/* <input
                  type="submit"
                  id="submit"
                  name="send"
                  className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5"
                  value="Save Changes"
                /> */}
              </form>
            </div>

            {/* <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                <div>
                  <h5 className="text-lg font-semibold mb-4">Contact Info :</h5>

                  <form>
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="form-label font-medium">
                          Phone No. :
                        </label>
                        <input
                          name="number"
                          id="number"
                          type="number"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Phone :"
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Website :
                        </label>
                        <input
                          name="url"
                          id="url"
                          type="url"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Url :"
                        />
                      </div>
                    </div>

                    <button className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5">
                      Save
                    </button>
                  </form>
                </div>

                <div>
                  <h5 className="text-lg font-semibold mb-4">
                    Change password :
                  </h5>
                  <form>
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="form-label font-medium">
                          Old password :
                        </label>
                        <input
                          type="password"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Old password"
                          required=""
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          New password :
                        </label>
                        <input
                          type="password"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="New password"
                          required=""
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Re-type New password :
                        </label>
                        <input
                          type="password"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Re-type New password"
                          required=""
                        />
                      </div>
                    </div>

                    <button className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5">
                      Save password
                    </button>
                  </form>
                </div>
              </div>
            </div> */}

            <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                {/* Skills Section */}
                <div className="section mt-6">
                  <h5 className="text-lg font-semibold mb-4">Skills:</h5>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      // checkForms(e);
                      // console.log("Form Data:", skillform);
                      setSkills([
                        ...skills,
                        { name: skillform.name, skill: skillform.proficiency },
                      ]);
                      setSkillform({
                        name: "",
                        proficiency: 0,
                      });
                      // handleUserSubmit();
                    }}
                  >
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="form-label font-medium">
                          Skill Name :
                        </label>
                        <input
                          name="name"
                          id="skill-name"
                          type="text"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Enter skill name"
                          value={skillform.name}
                          onChange={handleSkillChange}
                          required
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Proficiency (0 to 100) :
                        </label>
                        <input
                          name="proficiency"
                          id="skill-level"
                          type="range"
                          min="0"
                          max="100"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2 w-full"
                          value={skillform.proficiency}
                          // onChange={(e) => setSkillLevel(e.target.value)}
                          onChange={handleSkillChange}
                          required
                        />
                        <output className="ml-2">
                          {skillform.proficiency}
                        </output>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5"
                      // onClick={(e) => {
                      //   // checkForms(e);
                      //   setSkills([
                      //     ...skills,
                      //     { name: skillName, skill: skillLevel },
                      //   ]);
                      // }}
                    >
                      Add Skill
                    </button>
                  </form>

                  {/* Display added skills */}
                  <div id="skills-list" className="mt-6">
                    {skills.map((skill, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setSkillform({
                            name: skills[index].name,
                            proficiency: skills[index].skill,
                          });
                          setSkills((prevskill) => {
                            return prevskill.filter(
                              (myskill, idx) => idx !== index
                            );
                          });
                        }}
                        className="mb-4 bg-slate-50 w-fit px-5 cursor-pointer"
                      >
                        <strong>{skill.name}</strong> - Level: {skill.skill}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Experience Section */}
                <div className="section mt-6">
                  <h5 className="text-lg font-semibold mb-4">Experience:</h5>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      console.log(expform);
                      setExperiences([
                        ...experiences,
                        {
                          companyName: expform.name,
                          companyYears: expform.years,
                          companyLocation: expform.location,
                          experienceInfo: expform.info,
                        },
                      ]);
                      setExpform({
                        name: "",
                        years: 0,
                        location: "",
                        info: "",
                      });
                      // handleUserSubmit();
                    }}
                  >
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="form-label font-medium">
                          Company Name :
                        </label>
                        <input
                          name="name"
                          id="company-name"
                          type="text"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Enter company name"
                          value={expform.name}
                          onChange={handleExpChange}
                          required
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Years at Company :
                        </label>
                        <input
                          name="years"
                          id="company-years"
                          type="number"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Enter number of years"
                          value={expform.years}
                          onChange={handleExpChange}
                          required
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Location :
                        </label>
                        <input
                          name="location"
                          id="company-location"
                          type="text"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Enter location"
                          value={expform.location}
                          onChange={handleExpChange}
                          required
                        />
                      </div>

                      <div>
                        <label className="form-label font-medium">
                          Experience Info :
                        </label>
                        <textarea
                          name="info"
                          id="experience-info"
                          className="form-input border border-slate-100 dark:border-slate-800 mt-2"
                          placeholder="Describe your experience"
                          rows="4"
                          value={expform.info}
                          onChange={handleExpChange}
                          required
                        ></textarea>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5"
                      // onClick={(e) =>
                      //   setExperiences([
                      //     ...experiences,
                      //     {
                      //       companyName: companyName,
                      //       companyYears: companyYears,
                      //       companyLocation: companyLocation,
                      //       experienceInfo: experienceInfo,
                      //     },
                      //   ])
                      // }
                    >
                      Add Experience
                    </button>
                  </form>

                  {/* Display added experiences */}
                  <div id="experience-list" className="mt-6">
                    {experiences.map((exp, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setExpform({
                            name: exp.companyName,
                            years: exp.companyYears,
                            location: exp.companyLocation,
                            info: exp.experienceInfo,
                          });
                          setExperiences((prevExp) => {
                            return prevExp.filter(
                              (myprevExp, idx) => idx !== index
                            );
                          });
                        }}
                        className="mb-4 bg-slate-50 w-fit px-5 cursor-pointer"
                      >
                        <strong>{exp.companyName}</strong> - {exp.companyYears}{" "}
                        years at {exp.companyLocation} <br />
                        <em>{exp.experienceInfo}</em>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex w-full justify-center align-middle items-center">
              <button
                type="submit"
                id="submit"
                name="send"
                className="btn bg-indigo-600 hover:bg-indigo-700  text-white rounded-md mt-5"
                onClick={handleUserSubmit}
              >
                Save changes
              </button>
            </div>
            {/* <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <h5 className="text-lg font-semibold mb-4">Social Media :</h5>

              <div className="md:flex">
                <div className="md:w-1/3">
                  <span className="font-medium">Twitter</span>
                </div>

                <div className="md:w-2/3 mt-4 md:mt-0">
                  <form>
                    <div className="form-icon relative">
                      <Twitter className="size-4 absolute top-5 start-4" />
                      <input
                        type="text"
                        className="form-input border border-slate-100 dark:border-slate-800 mt-2 ps-12"
                        placeholder="Twitter Profile Name"
                        id="twitter_name"
                        name="name"
                        required=""
                      />
                    </div>
                  </form>

                  <p className="text-slate-400 mt-1">
                    Add your Twitter username (e.g. jennyhot).
                  </p>
                </div>
              </div>

              <div className="md:flex mt-8">
                <div className="md:w-1/3">
                  <span className="font-medium">Facebook</span>
                </div>

                <div className="md:w-2/3 mt-4 md:mt-0">
                  <form>
                    <div className="form-icon relative">
                      <Facebook className="size-4 absolute top-5 start-4" />
                      <input
                        type="text"
                        className="form-input border border-slate-100 dark:border-slate-800 mt-2 ps-12"
                        placeholder="Facebook Profile Name"
                        id="facebook_name"
                        name="name"
                        required=""
                      />
                    </div>
                  </form>

                  <p className="text-slate-400 mt-1">
                    Add your Facebook username (e.g. jennyhot).
                  </p>
                </div>
              </div>

              <div className="md:flex mt-8">
                <div className="md:w-1/3">
                  <span className="font-medium">Instagram</span>
                </div>

                <div className="md:w-2/3 mt-4 md:mt-0">
                  <form>
                    <div className="form-icon relative">
                      <Instagram className="size-4 absolute top-5 start-4" />
                      <input
                        type="text"
                        className="form-input border border-slate-100 dark:border-slate-800 mt-2 ps-12"
                        placeholder="Instagram Profile Name"
                        id="insta_name"
                        name="name"
                        required=""
                      />
                    </div>
                  </form>

                  <p className="text-slate-400 mt-1">
                    Add your Instagram username (e.g. jennyhot).
                  </p>
                </div>
              </div>

              <div className="md:flex mt-8">
                <div className="md:w-1/3">
                  <span className="font-medium">Linkedin</span>
                </div>

                <div className="md:w-2/3 mt-4 md:mt-0">
                  <form>
                    <div className="form-icon relative">
                      <Linkedin className="size-4 absolute top-5 start-4" />
                      <input
                        type="text"
                        className="form-input border border-slate-100 dark:border-slate-800 mt-2 ps-12"
                        placeholder="Linkedin Profile Name"
                        id="linkedin_name"
                        name="name"
                        required=""
                      />
                    </div>
                  </form>

                  <p className="text-slate-400 mt-1">
                    Add your Linkedin username.
                  </p>
                </div>
              </div>

              <div className="md:flex mt-8">
                <div className="md:w-1/3">
                  <span className="font-medium">Youtube</span>
                </div>

                <div className="md:w-2/3 mt-4 md:mt-0">
                  <form>
                    <div className="form-icon relative">
                      <Youtube className="size-4 absolute top-5 start-4" />
                      <input
                        type="url"
                        className="form-input border border-slate-100 dark:border-slate-800 mt-2 ps-12"
                        placeholder="Youtube url"
                        id="you_url"
                        name="url"
                        required=""
                      />
                    </div>
                  </form>

                  <p className="text-slate-400 mt-1">Add your Youtube url.</p>
                </div>
              </div>

              <div className="md:flex">
                <div className="md:w-1/3">
                  <input
                    type="submit"
                    id="submit"
                    name="send"
                    className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md mt-5"
                    value="Save Changes"
                  />
                </div>
              </div>
            </div> */}

            {/* <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <h5 className="text-lg font-semibold mb-5">
                Account Notifications :
              </h5>

              <div className="flex justify-between pb-4">
                <h6 className="mb-0 font-medium">When someone mentions me</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    id="noti1"
                  />
                  <label className="form-check-label" htmlFor="noti1"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">When someone follows me</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    defaultChecked
                    id="noti2"
                  />
                  <label className="form-check-label" htmlFor="noti2"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">When shares my activity</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    id="noti3"
                  />
                  <label className="form-check-label" htmlFor="noti3"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">When someone messages me</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    id="noti4"
                  />
                  <label className="form-check-label" htmlFor="noti4"></label>
                </div>
              </div>
            </div> */}

            {/* <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <h5 className="text-lg font-semibold mb-5">
                Marketing Notifications :
              </h5>

              <div className="flex justify-between pb-4">
                <h6 className="mb-0 font-medium">
                  There is a sale or promotion
                </h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    id="noti5"
                  />
                  <label className="form-check-label" htmlFor="noti5"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">Company news</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    id="noti6"
                  />
                  <label className="form-check-label" htmlFor="noti6"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">Weekly jobs</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    defaultChecked
                    id="noti7"
                  />
                  <label className="form-check-label" htmlFor="noti7"></label>
                </div>
              </div>
              <div className="flex justify-between py-4 border-t border-gray-100 dark:border-gray-700">
                <h6 className="mb-0 font-medium">Unsubscribe News</h6>
                <div className="">
                  <input
                    className="form-checkbox rounded border-gray-200 dark:border-gray-800 text-indigo-600 focus:border-emerald-300 focus:ring focus:ring-offset-0 focus:ring-emerald-200 focus:ring-opacity-50"
                    type="checkbox"
                    value=""
                    defaultChecked
                    id="noti8"
                  />
                  <label className="form-check-label" htmlFor="noti8"></label>
                </div>
              </div>
            </div> */}

            <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
              <h5 className="text-lg font-semibold mb-5 text-red-600">
                Delete Account :
              </h5>

              <p className="text-slate-400 mb-4">
                Do you want to delete the account? Please press below "Delete"
                button
              </p>

              <button
                onClick={() => {
                  // const response=confirm("Are You sure you want to delete your account")

                  alert(
                    "Account Deletion request submitted \n Your account will be deleted in 15 days , if you login again your deletion will be stopped"
                  );
                }}
                className="btn bg-red-600 hover:bg-red-700 text-white rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
